import React from "react";
import useStyles from "./FmUnderlineNav.style";
import { useSelector } from "react-redux";
import { GeneralState } from "../../Redux";
import { useTranslation } from "react-i18next";

interface FmUnderlineNavProps {
    title: string;
    bold?: boolean;
    onClick?: () => void;
    disabled?: boolean;
}

const FmUnderlineNav = ({ title, onClick, bold, disabled }: FmUnderlineNavProps) => {
    const { t } = useTranslation();
    const classes = useStyles();
    const greenBar = useSelector(GeneralState.Selectors.selectGreenBarState);
    const isSavedItem = title == t("saveItemPopup.save") && greenBar.isShow;
    return (
        <div>
            {isSavedItem ? (
                <></>
            ) : (
                <div onClick={onClick} className={`${bold ? classes.bold_container : classes.container} ${disabled && classes.disabled}`}>
                    {title}
                </div>
            )}
        </div>
    );
};

export default FmUnderlineNav;
